import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import axios from "axios";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import { throwStatement } from "@babel/types";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const CreateContentTemplateType = () => {
  const [contentTemplateTypeCodes, setContentTemplateTypeCodes] = useState([]);

	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentTemplateTypeId: 0,
    contentTemplateValueCode: 0,
    contentTemplateTypeCdata: "",
    contentTemplateTypeBdata: "",
    securityContextId: 0,
    createUser: 0,
    createDate: new Date(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date(),
    contentTemplateTypeDescr: "",
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-template-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-template-types/contentTemplateTypeId`;
    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentTemplateTypeId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentTemplateTypeId
          );
          // && response2.data.contentTemplateTypeId === this.state.contentTemplateTypeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      //     console.log(response.data)
      //          .catch(err => {
      //             console.log(err);
      //           });
      console.log("message info - " + message);
      setState({ ...state, contentTemplateTypeDescr: " " });
    });

    // console.log("SetState Message info-"+this.contentObjectName);
    // console.log("SetState Message info-"+this.contentCategoryName);
    // console.log("SetState Message info-"+this.contentCategoryDescr);
  }
  function handRest() {
    setState({ ...state, contentTemplateTypeDescr: "" });
  }

  const handleOnLoad = () => {
//     console.log("i start ooo");
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_TEMPLATE_TYPE_CODE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentTypes = res.data;
        console.log("results", contentTypes);
        setContentTemplateTypeCodes(contentTypes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };
  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Template Type</h4>			
			<Link to="/breeze/list-content-template-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">
            Content Template Type Description
          </label>
          <input
            id="contentTemplateTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateTypeDescr}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">
            Content Template Value Code
          </label>
          <select
            id="contentTemplateValueCode"
            className="form-control input-xlarge col-sm-8"
            value={state.contentTemplateValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('CONTENT_TEMPLATE_TYPE_CODE')}" /> */}

            <option value={0}>Select Template Value Type</option>
            {contentTemplateTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" >Content Template Type CData</label>
				<input id="contentTemplateTypeCdata" className="form-control input-xlarge col-sm-8" value="#{ombContentTemplateTypeForm.createContentTemplateType.contentTemplateTypeCdata}"/>
	 			</div> */}
        <hr />
        <button className="btn btn-primary" value="Clear" onClick={handRest}>
          Clear
        </button>
        &nbsp;
        <button
          className="btn btn-success"
          value="Create"
          onClick={handleSubmit}
        >
          Create
        </button>
      </div>
    </form>
  );
};

export default CreateContentTemplateType;
